import { useNavigate, useSearchParams } from 'react-router-dom'
import { useInventorySystemProfileToVenues } from '../../hooks/useInventorySystemProfileToVenues'
import { useInventorySystemProfiles } from '../../hooks/useInventorySystemProfiles'
import { useVenues } from '../../hooks/useVenues'
import { useTenantGroups } from '../../hooks/useTenantGroups'
import { InventorySystemProfileToVenuesTable } from '../../components/InventorySystemProfileToVenuesTable/InventorySystemProfileToVenuesTable'
import { ListFilterBar } from '../../components/ListFilterBar/ListFilterBar'
import { ListEntityPage } from '../ListEntityPage/ListEntityPage'
import { buildListFiltersSearchParams } from '../helpers/buildListFiltersSearchParams'
import { filterInventorySystemProfileToVenues } from './helpers/filterInventorySystemProfileToVenues'
import { readListFiltersFromParams } from '../helpers/readListFiltersFromParams'
import { buildInventorySystemProfileToVenuesFilterFields } from './helpers/buildInventorySystemProfileToVenuesFilterFields'

export function InventorySystemProfileToVenuesPage() {
  const navigate = useNavigate()
  const {
    mappings,
    isLoading: mappingsLoading,
    error: mappingsError,
  } = useInventorySystemProfileToVenues()
  const {
    profiles,
    isLoading: profilesLoading,
    error: profilesError,
  } = useInventorySystemProfiles()
  const { venues, isLoading: venuesLoading, error: venuesError } = useVenues()
  const {
    tenantGroups,
    isLoading: groupsLoading,
    error: groupsError,
  } = useTenantGroups()

  const isLoading =
    mappingsLoading || profilesLoading || venuesLoading || groupsLoading
  const error = mappingsError ?? profilesError ?? venuesError ?? groupsError
  const [searchParams, setSearchParams] = useSearchParams()
  const filterFields = buildInventorySystemProfileToVenuesFilterFields(
    profiles,
    tenantGroups
  )
  const filters = readListFiltersFromParams(searchParams, filterFields)
  const filteredMappings = filterInventorySystemProfileToVenues(
    mappings,
    venues,
    filters
  )

  return (
    <ListEntityPage
      title="ISP to venues"
      description="Links between inventory system profiles and the venues they supply. The system creates these in the background; change them here only to repair a missing or wrong link."
      loadingLabel="ISP to venue mappings"
      isLoading={isLoading}
      error={error}
      createHref="/isp-to-venues/create"
      createLabel="New ISP to venue mapping"
    >
      <ListFilterBar
        fields={filterFields}
        initialValues={filters}
        onChange={(next) =>
          setSearchParams(
            buildListFiltersSearchParams(searchParams, filterFields, next)
          )
        }
      />
      <InventorySystemProfileToVenuesTable
        mappings={filteredMappings}
        profiles={profiles}
        venues={venues}
        tenantGroups={tenantGroups}
        onRowClick={(m) =>
          navigate(`/isp-to-venues/${m.inventorySystemProfileId}/${m.venueId}`)
        }
      />
    </ListEntityPage>
  )
}
